"use client";

import Photo from "./Photo";
import Social from "./Social";
import Stats from "./Stats";
import { Button } from "./ui/button";
import Link from "next/link";
import { FiDownload } from "react-icons/fi";
import { useTranslations } from "next-intl";
import HomeScrollLock from "./HomeScrollLock";

export default function HomeContent() {
  const t = useTranslations("home");

  return (
    <section className="home-lock flex flex-col xl:h-[calc(100dvh-4rem)] xl:max-h-[calc(100dvh-4rem)] xl:overflow-hidden">
      <HomeScrollLock />
      <div className="container mx-auto flex-1 flex flex-col min-h-0 xl:justify-center">
        <div className="flex flex-col xl:flex-row items-center justify-between gap-6 xl:gap-10 xl:py-2">
          <div className="text-center xl:text-left order-2 xl:order-none xl:max-w-[52%]">
            <span className="hero-role text-base xl:text-lg cursor-target justify-center xl:justify-start">
              {t("role")}
            </span>
            <h1 className="h1 mb-3 mt-2 xl:mb-4 xl:text-[64px]">
              <span className="cursor-target text-white/90">{t("hello")}</span>
              <br />
              <span className="text-accent cursor-target">Parth Kalani</span>
            </h1>
            <p className="max-w-[500px] mb-3 xl:mb-4 text-white/75 cursor-target mx-auto xl:mx-0 leading-relaxed text-[15px] xl:text-base">
              {t("bio")}
            </p>
            <Link
              className="inline-block max-w-[500px] mb-4 xl:mb-5 text-accent/90 hover:text-accent transition-colors cursor-target"
              href={"https://masterutils.com/"}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("masterTools")}
            </Link>
            <div className="flex flex-col xl:flex-row items-center gap-5 xl:gap-6 mt-2">
              <a
                href="/assets/resume/Parth-Resume-2026.pdf"
                target="_blank"
                rel="noopener noreferrer"
                download="Parth-Resume-2026.pdf"
                className="uppercase flex items-center gap-2 rounded-full"
              >
                <Button
                  variant="outline"
                  size="lg"
                  className="uppercase flex items-center gap-2 rounded-full cursor-target"
                >
                  <span>{t("downloadCv")}</span>
                  <FiDownload className="text-xl" />
                </Button>
              </a>
              <div className="mb-6 xl:mb-0 cursor-target">
                <Social
                  containerStyles="flex gap-6"
                  iconStyles="w-9 h-9 border border-accent rounded-full flex justify-center items-center text-accent text-base hover:bg-accent hover:text-primary hover:transition-all duration-500 cursor-target"
                />
              </div>
            </div>
          </div>
          <div className="order-1 xl:order-none mb-4 xl:mb-0 cursor-target shrink-0">
            <Photo />
          </div>
        </div>
      </div>
      <Stats />
    </section>
  );
}
